import { units } from '@ui/css';
import { makeScaleableToken, combineTokens, makeColorToken, makeSelectors } from '@utils/css';

const borderHeight = makeScaleableToken("--tablist--border-height", units.px(3));
const tablistCssTokens = combineTokens("--tablist--", {
  scrollGradientColorRgb: ["255 255 255", makeColorToken],
  borderHeight: borderHeight(),
  indicatorHeight: borderHeight.__extend("--tablist--indicator-height")()
});
const scrollContentWrapper = "dibs1an7s9d";
const scrollButton = "dibsvsdtgs";
const tabWrapper = "dibtag0jnx";
const tabGroup = "dibt1hhak3z";
const separator = "dibs4ht892";
const tablistSelectors = makeSelectors({
  tabGroup,
  tabWrapper
});

export { scrollButton, scrollContentWrapper, separator, tabGroup, tabWrapper, tablistCssTokens, tablistSelectors };
import "./tablist.style.linaria.module.css";
//# sourceMappingURL=tablist.style.js.map
